var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPersonalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.7 19.063-2.474 2.475a5.513 5.513 0 0 1-7.788-7.787l3.538-3.525a5.49 5.49 0 0 1 7.775 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m11.277 4.913 2.475-2.475a5.512 5.512 0 0 1 7.787 7.788l-3.537 3.525a5.49 5.49 0 0 1-7.775 0"
})));
export default SvgPersonalLink;